<template>
  <data-manager-layout>
    <el-button
      v-if="!readonly && $can('MetabaseComputation:ReadAccess')"
      slot="actions"
      icon="el-icon-setting"
      type="primary"
      :plain="true"
      @click="manageComputations"
      data-qa="manage-computations"
    >
      {{ $t('DataManager_Button_ManageComputations') }}
    </el-button>

    <rest-list
      :payload="fetchEndpoint"
      :after-fetch="transformTags"
      ref="rest-list"
    >
      <rest-list-column
        prop="title"
        :title="$t('DataManager_Tags_Field_Title')"
      />

      <rest-list-column-enum
        prop="type"
        :title="$t('DataManager_Tags_Field_Type')"
        :number="true"
        :enum="TagTypeLabels"
      />

      <rest-list-column
        prop="lastRun"
        :title="$t('DataManager_Tags_Field_LastRun')"
        :filterable="false"
        :sortable="false"
        :filter-input="false"
        :width="200"
      >
        <template slot-scope="scope">
          <template v-if="!scope.row.metabase_card_id">
            Realtime
          </template>
          <template v-else-if="scope.row.lastRun">
            <router-link :to="taskRoute(scope.row.lastRun)" class="taskLink">
              <el-link
                :type="taskStatusDetails(scope.row.lastRun.status).type"
                :icon="taskStatusDetails(scope.row.lastRun.status).icon"
                :underline="false"
              />
              {{ dateFormatter(scope.row.lastRun.create_time) }}
            </router-link>
          </template>
          <template v-else>
            -
          </template>
        </template>
      </rest-list-column>

      <el-table-column
        :width="50"
        align="center"
        class-name="editable-row-actions"
        :fixed="false"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.is_deleted"
            class="el-icon-warning-outline"
            :title="$t('DataManager_Tags_Action_CancelDelete')"
          />
        </template>
      </el-table-column>
    </rest-list>
  </data-manager-layout>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import { TagType, TagTypeLabels } from '@/modules/data-manager/enum/TagTypeEnum'
import DataManagerLayout from '@/modules/data-manager/pages/DataManagerLayout'
import RestApi from '@/core/services/RestApi'
import RestList from '@/common/components/rest/RestList'
import {
  projectRoute,
  projectTimezoneDate,
  projectEndpoint,
  getEnumTranslations
} from '@/core/helpers'
import {
  taskStatusEnum,
  taskStatusLabel
} from '@/modules/tasks/enum/TaskRecordEnums'

export default {
  name: 'DataManagerAggregatesPage',

  components: {
    RestList,
    DataManagerLayout,
    RestListColumn,
    RestListColumnEnum
  },

  data() {
    return {
      aliases: [],
      TagType,
      TagTypeLabels,
      taskStatusEnum,
      taskStatusLabel
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`,
        params: {
          aggregate: 1,
          sort: 'title',
          expand: 'lastRun'
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    },

    restList() {
      return this.$refs['rest-list'].$refs['restList']
    },

    filterOptions() {
      return getEnumTranslations(this.TagTypeLabels)
    }
  },

  methods: {
    manageComputations() {
      this.$router.push(
        projectRoute({
          name: 'MetabaseComputationList'
        })
      )
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `tags/${row.id}`
      })
    },

    cancelDelete(row) {
      this.$msgbox({
        title: this.$t('DataManager_Tags_Action_CancelDelete_Title'),
        message: this.$t('DataManager_Tags_Action_CancelDelete_Message'),
        showCancelButton: true,
        confirmButtonText: this.$t('DataManager_Tags_Action_CancelDelete_Keep'),
        cancelButtonText: this.$t('RestList_SaveCancelButton'),
        center: true
      }).then(() => {
        RestApi(
          projectEndpoint({
            method: 'patch',
            url: `tags/${row.id}`,
            data: {
              is_deleted: 0
            }
          })
        )
          .then(() => {
            this.$message({
              message: this.$t('RestList_CancelSuccessMessage'),
              type: 'success'
            })
            this.restList.refresh()
          })
          .catch(error => {
            this.restList.loading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    },

    taskStatusDetails(status) {
      if (
        status === this.taskStatusEnum.NEW ||
        status === this.taskStatusEnum.EXECUTING
      ) {
        return {
          icon: 'el-icon-loading',
          type: 'warning',
          message: this.$t('TaskHistory_StatusLoading')
        }
      } else if (
        status === this.taskStatusEnum.ERROR ||
        status === this.taskStatusEnum.FATAL
      ) {
        return {
          icon: 'el-icon-error',
          type: 'danger',
          message: this.$t(this.taskStatusLabel[status])
        }
      } else {
        return {
          icon: 'el-icon-success',
          type: 'success',
          message: this.$t(this.taskStatusLabel[status])
        }
      }
    },

    taskRoute(task) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: task.id }
      })
    },

    dateFormatter(value) {
      return projectTimezoneDate(value).format('DD MMM YYYY HH:mm:ss')
    },

    transformTags() {
      this.$refs['rest-list'].data = this.$refs['rest-list'].data.map(item => {
        return this.transformTag(item)
      })
    },

    transformTag(item) {
      return {
        ...item,
        title: item.name,
        name: item.display_name
      }
    }
  }
}
</script>

<style scoped>
>>> .el-icon-warning-outline {
  color: #e74c3c;
}
.taskLink {
  text-decoration: none !important;
}
.taskLink .el-link {
  text-decoration: none !important;
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerAggregatesPage.vue